<script>
import { provide, ref } from 'vue-demi'
import { PROVIDE_KEYS, ACTIVE_PAGE } from './consts'

export default {
  setup () {
    const activePage = ref(ACTIVE_PAGE.ENGINEER_DASHBOARD)
    provide(PROVIDE_KEYS.ACTIVE_PAGE, activePage)
  },
  render () {
    const slot = this.$scopedSlots.default()
    return Array.isArray(slot) ? slot[0] : slot
  },
}
</script>
